import { FoodsBadge, WhiteBox } from "@foodpilot/foods";
import { Grid2, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { ValidatedState, ValidatedTag } from "../../ValidatedTag";
import { QuestionnaireOverview, ScoreOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { ScoresBodyOverview } from "../../Overview/Scores/ScoresBodyOverview";

type Props = {
    scores: ScoreOverview[];
    ssq: QuestionnaireOverview;
};
export const ScoresAndIndicators = (props: Props) => {
    const theme = useTheme();

    const { scores, ssq } = props;

    // Rule defined in backend
    const isIncomplete = scores.some((score) => score.isComplete === false);
    return (
        <WhiteBox>
            <Stack padding={{ xs: theme.spacing(2), sm: theme.spacing(3) }} gap={theme.spacing(3)}>
                <ScoresAndIndicatorsHeader isIncomplete={isIncomplete} />
                <Grid2 container spacing={theme.spacing(1)}>
                    {scores.map((scoreOverview) => {
                        const doesPostExist = ssq.post !== null;
                        return (
                            <ScoresBodyOverview
                                key={`${scoreOverview.id}_${scoreOverview.ssq.id}`}
                                scoreOverview={scoreOverview}
                                doesPostExist={doesPostExist}
                            />
                        );
                    })}
                </Grid2>
            </Stack>
        </WhiteBox>
    );
};

type HeaderProps = {
    isIncomplete?: boolean;
};
const ScoresAndIndicatorsHeader = (props: HeaderProps) => {
    const theme = useTheme();
    const datavizColors = theme.custom.dataviz.colorsWithExtra[2];
    const { isIncomplete = false } = props;

    const tagState: ValidatedState = isIncomplete === false ? null : "incomplete";

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection="row" gap={theme.spacing(2)} alignItems={"center"}>
                <FoodsBadge
                    size={7}
                    icon={"scoresIndicators"}
                    boxProps={{
                        sx: {
                            color: theme.palette.primary[500],
                            backgroundColor: theme.palette.primary[50],
                            borderRadius: "8px",
                        },
                    }}
                />
                <Stack>
                    <Typography variant="h3">
                        {t("company.overview.scores_title", "My scores and indicators")}
                    </Typography>
                </Stack>
                <ValidatedTag state={tagState} />
            </Stack>
        </Stack>
    );
};
